import React from "react"

const InlineScript = (props) => {
    const ctnId = `inline-script-container-${React.useId()}`
    
    React.useEffect(() => {
        const pps = props.attribs
        const el = document.getElementById(ctnId)
        let scpt
        if (pps.src) {
            if (el) {
                scpt = document.createElement('script')
                for(let pp in pps) {
                    scpt[pp] = pps[pp]
                }
                el.appendChild(scpt)
            }
        }

        return () => {
            if (el && scpt) {
                el.removeChild(scpt)
                el.innerHTML = ''
            }
        }
    }, [props.attribs, ctnId])
    return <div id={ctnId}></div>
}


export default InlineScript